<div class="benefit-accordion" [ngClass]="{ expanded: expanded }">
  <div class="benefit-header" (click)="toggle(benefit)">
    <div class="benefit-header-left">
      <span class="benefit-icon">
        <em class="icon-litegift-icon"></em>
      </span>
      <div class="benefit-title-container">
        <span class="benefit-title">{{ benefit?.title }}</span>
        <span class="benefit-subtitle" *ngIf="benefit?.subtitle">
          {{ benefit?.subtitle }}
        </span>
      </div>
    </div>
    <div class="benefit-toggle">
      <span class="toggle-label">
        {{ expanded ? hideAccordionText : showAccordionText }}
      </span>
      <em class="icon-litechevron_up" [ngClass]="{ rotated: !expanded }"></em>
    </div>
  </div>

  <div class="benefit-body" *ngIf="expanded">
    <div class="discount-code-section" *ngIf="benefit?.code">
      <span class="code-label">
        {{ CREATE_PLAN_CONSTANTS.REDEMPTION_CODE }}
      </span>
      <div class="code-main-container">
        <div class="code-container">
          <div class="code-container-inner">
            <span class="code-value">{{ benefit?.code }}</span>
            <span *ngIf="couponUsage" class="coupon-usage">
              {{ couponUsage?.remaining_uses }}
              {{
                couponUsage?.remaining_uses === Application.ONE
                  ? CREATE_PLAN_CONSTANTS.USE_LEFT
                  : CREATE_PLAN_CONSTANTS.USES_LEFT
              }}
              {{ couponUsage.validTill }}
            </span>
          </div>
        </div>
        <button class="copy-btn" (click)="copyCode()">
          <em class="icon-fi-sr-copy"></em>
        </button>
      </div>
    </div>

    <div *ngIf="benefit?.ids?.length" class="duration-options-container">
      <h6>
        {{ benefit?.optionTitle }}
      </h6>
      <div class="duration-options-grid">
        <div
          *ngFor="let pricePoint of benefit?.ids"
          class="duration-option-card"
        >
          <div class="d-flex flex-column">
            <span class="duration-label-exp">
              {{ pricePoint.title || pricePoint.unit_value }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="terms-section" *ngIf="benefit?.termsAndConditions?.length">
      <span class="terms-label">
        {{ CREATE_PLAN_CONSTANTS.TERMS_CONDITIONS }}
      </span>
      <ul class="terms-list">
        <li *ngFor="let term of benefit.termsAndConditions">{{ term }}</li>
      </ul>
    </div>
  </div>
</div>
